<template>
  <v-autocomplete
    v-model="brandValue"
    :items="
      withAllBrands
        ? [{ id: null, name: 'All brands' }, ...$store.state.brands]
        : $store.state.brands
    "
    :loading="isLoading"
    :search-input="searchBrand"
    item-text="name"
    item-value="id"
    return-object
    :disabled="disabled"
    outlined
    placeholder="Brand"
    clearable
    dense
    :multiple="multiple"
    @input="handleInput"
    :rules="rules"
  ></v-autocomplete>
</template>

<script>
export default {
  props: {
    withAllBrands: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },

    value: {
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchBrand: "",
      isLoading: false,
      brandValue: null
    }
  },
  created() {
    if (this.$store.state.globalBrand)
      if (!this.withAllBrands && this.$store.state.globalBrand?.id === null)
        this.$store.commit("setGlobalBrand", this.$store.state.brands[0])
      else this.brandValue = this.lo.cloneDeep(this.$store.state.globalBrand)
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.brandValue = newValue
      }
    }
  },
  methods: {
    handleInput() {
      const $ = this
      this.$nextTick(() => {
        $.$emit("input", this.brandValue)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
